import { Link } from "react-router-dom";
import EditableImage from "../components/EditableImage";
import { useMemberAuth, useAdminAuth } from "../lib/auth";

const MembersGate = () => {
  const { isAuthed: isMember } = useMemberAuth();
  const { isAuthed: isAdmin } = useAdminAuth();
  const canEnter = isMember || isAdmin;

  return (
    <div className="section-pad py-16 md:py-24 grid md:grid-cols-2 gap-12 items-stretch" data-testid="members-gate-page">
      <div className="overflow-hidden" style={{ aspectRatio: "4/5", minHeight: 400 }}>
        <EditableImage
          imageKey="members_gate"
          fallback="https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=1400&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col justify-center md:pl-10 py-8">
        <h1 className="font-display text-5xl sm:text-7xl uppercase tracking-tighter leading-[0.9]">
          Members Only.
        </h1>
        <div className="mt-8 text-sm text-black/70 leading-relaxed max-w-md">
          <p>
            Purchase from the public catalog to receive your invitation.
          </p>
        </div>
        <div className="mt-10 flex flex-wrap gap-3">
          {canEnter ? (
            <Link to="/members/catalog" className="btn-primary" data-testid="members-enter-catalog">
              {isAdmin && !isMember ? "Enter (Admin)" : "Enter"}
            </Link>
          ) : (
            <>
              <Link to="/hoodies" className="btn-primary" data-testid="members-shop-public">
                Shop
              </Link>
              <Link to="/members/login" className="btn-secondary" data-testid="members-login-link">
                Sign In
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MembersGate;
